export const UPLOAD_EPOINTS_ANKETA = 'epoints/upload-anketa';
export const LOAD_EPOINTS_INFO = 'epoints/load-info';
export const GET_EPOINTS_MEMBERSHIP = 'epoints/get-membership';
export const GET_EPOINTS_BALANCE = 'epointsget-balance';
export const SHOW_EPOINTS_POPUP = 'epoints/show-popup';
export const HIDE_EPOINTS_POPUP = 'epoints/hide-pupup';
export const SET_ACTIVE_POPUP_FRAME = 'epoints/set-active-popup-frame';
export const SET_RESET_POPUP_FRAME = 'epoints/set-reset-popup-frame';
export const SET_EMAIL_ERROR = 'epoints/set-email-error';
